import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const  useUpdateInternalTrackerOptions =() => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body, config}) => {
        return axios.post(`${process.env.REACT_APP_API_URI}InternalTrackerUpdate`, body, config);
      },
      onSuccess: () => {
           queryClient.invalidateQueries([QUERY_KEYS.INTERNALTRACKERGETDATA])
      }
    });
  }